export { FavoriteHeartIcon } from './FavoriteHeartIcon';
